
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import ConstantsResult from "domains/entity/main/ConstantResult";
import DisiApi from "datas/disi/DisiApi";
import MerchantDepositUseCase from "domains/interactor/main/disi/MerchantDeposit";

type iState = {
    data: ConstantsResult;
    error: any;
    loading: boolean;
}

const initialState: iState = {
    data: [],
    error: "",
    loading: false
}

export const merchantDepositBanksAction = createAsyncThunk('merchant-deposit-banks-list', async (_, { rejectWithValue }) => {
    try {
        const useCase = new MerchantDepositUseCase(new DisiApi())

        return await useCase.getMerchantDepositBankList("bank")

    } catch (error) {
        const { response = null } = error

        if (!response) {
            throw error
        }

        return rejectWithValue(response.data)
    }
})

const merchantDepositBankSlice = createSlice(
    {
        name: "merchant-deposit-banks-slice",
        initialState,
        reducers: {},
        extraReducers: builder => {
            builder.addCase(merchantDepositBanksAction.pending, state => {
                state.error = ""
                state.loading = true
            })

            builder.addCase(merchantDepositBanksAction.fulfilled, (state, action) => {
                state.loading = false;
                state.error = ""
                state.data = action.payload
            })

            builder.addCase(merchantDepositBanksAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload
            })
        }
    }
)

const merchantDepositBankReducer = merchantDepositBankSlice.reducer

export default merchantDepositBankReducer